import styled from 'styled-components';
import CallHotelSvg from '../../assets/mytrips/call-hotel.svg';

const CallHotelIcon = styled(CallHotelSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.5rem'};
  margin: ${props => props.margin};
`;

export default CallHotelIcon;
